import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';

export interface GetUserSegmentResult {
  segment?: string;
  message?: string;
}

export const getUserSegment = async ({
  host,
  sessionId,
}: {
  host: string;
  sessionId: string;
}): Promise<GetUserSegmentResult> => {
  const response = await axiosClient.get<GetUserSegmentResult>(`${assertServiceHost(host)}/segment`, {
    headers: {
      'everhelper-session-id': sessionId,
    },
  });
  return response.data;
};
